import { render, staticRenderFns } from "./moca.vue?vue&type=template&id=1ec11685&scoped=true"
import script from "./moca.vue?vue&type=script&lang=js"
export * from "./moca.vue?vue&type=script&lang=js"
import style0 from "./moca.vue?vue&type=style&index=0&id=1ec11685&prod&lang=less"
import style1 from "./moca.vue?vue&type=style&index=1&id=1ec11685&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec11685",
  null
  
)

export default component.exports